module.exports = __webpack_public_path__ + "static/img/3.cdaa40d6.png";